import { useWorkflowContext } from "@rapid/contexts/WorkflowContext";

export function useCurrentWorkflow() {
    return useWorkflowContext();
}
